import SelectTalent from './SelectTalent';

export default SelectTalent;
